import { State } from '@progress/kendo-data-query'

import {
  BOOKING_SET_CURRENT_BOOKING,
  BOOKING_SET_DATA,
  BOOKING_SET_DATASTATE,
  BOOKING_SET_LOADING,
  BOOKING_SET_MODAL_CONFIRMACION,
  BOOKING_SET_MODAL_FACTURACION,
  BOOKING_SET_MODAL_NOTA_CREDITO,
  SET_BOOKINGS_RESERVAS,
  SET_SELECT_BOOKING_RESERVAS,
} from './actionsTypes'

import { TAKEBOOKINGS } from '@/common/constants/default'
import { IBooking, IBookingsState, IOpenModalConfirmar, IItemBooking } from '@/common/interfaces/booking'
import { Action } from '@/common/interfaces/general'

export const initialBookingState: State = {
  take: TAKEBOOKINGS,
  skip: 0,
  sort: [{ field: 'FechaCreacion', dir: 'desc' }],
}

const INIT_STATE: IBookingsState = {
  loading: true,
  dataState: initialBookingState,
  bookings: { data: [] as IBooking[], total: 0 },
  bookingsReservas: [] as IItemBooking[],
  selectBookingReserva: {} as IItemBooking,
  modalFacturacion: false,
  modalNotaCredito: false,
  modalConfirmacion: {} as IOpenModalConfirmar,
}

const action: Action<any> = {
  type: '',
  payload: '',
}

export const BookingReduce = (state = INIT_STATE, { type, payload } = action): IBookingsState => {
  switch (type) {
    case BOOKING_SET_DATASTATE:
      return {
        ...state,
        dataState: payload,
      }

    case BOOKING_SET_CURRENT_BOOKING:
      return {
        ...state,
        selectedBooking: payload,
      }

    case BOOKING_SET_DATA:
      return {
        ...state,
        bookings: payload,
      }

    case BOOKING_SET_MODAL_FACTURACION:
      return {
        ...state,
        modalFacturacion: payload,
      }

    case BOOKING_SET_MODAL_NOTA_CREDITO:
      return {
        ...state,
        modalNotaCredito: payload,
      }

    case BOOKING_SET_LOADING:
      return {
        ...state,
        loading: payload,
      }

    case BOOKING_SET_MODAL_CONFIRMACION:
      return {
        ...state,
        modalConfirmacion: payload,
      }

    case SET_BOOKINGS_RESERVAS:
      return {
        ...state,
        bookingsReservas: payload,
      }

    case SET_SELECT_BOOKING_RESERVAS:
      return {
        ...state,
        selectBookingReserva: payload,
      }

    default:
      // El mismo objeto, no una copia: devolver `{...state}` creaba un estado nuevo ante
      // CUALQUIER acción de la aplicación, y todo suscriptor del slice re-renderizaba siempre
      // (react-redux compara por referencia) — hasta el vencimiento del timer de un toast
      // re-renderizaba el visor entero y remontaba las celdas del grid.
      return state
  }
}

export default BookingReduce
